import { CityActions } from '../actions';
import { CityState } from '../city-state';

export const initialState: CityState['city'] = {
  noDeliveryIsShowing: true,
};

export function reducer(state = initialState, action: CityActions.CityAction): CityState['city'] {
  switch (action.type) {
    case CityActions.CITY_MARK_SHOWN_NO_DELIVERY: {
      return { ...state, noDeliveryIsShowing: false };
    }

    default: {
      return state;
    }
  }
}
